import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function CountryModal(props) {
  const BASE_URL_CA = 'https://www.hearttohomemeals.ca';
  const BASE_URL_US = 'https://hearttohomemeals.com';

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="modal-title">
          Choose your Heart To Home Meals website
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
                    <div className="container-fluid">
                        <div className="row p-2">
                            <div className="col-8 offset-2 align-middle">
                                <img src={`${BASE_URL_CA}/CMSPages/GetResource.ashx?image=[Images.zip]/Flags/48x48/en-CA.png`} alt="Canada Flag" width="32" />
                                <a className="ml-3" href={`${BASE_URL_CA}?remembersite=true`}>Canada</a>
                            </div>
                        </div>
                        <div className="row p-2">
                            <div className="col-8 offset-2 align-middle">
                                <img src={`${BASE_URL_CA}/CMSPages/GetResource.ashx?image=[Images.zip]/Flags/48x48/en-US.png`} alt="USA flag" width="32" />
                                <a className="ml-3" href={`${BASE_URL_US}?remembersite=true`} >United States</a>
                            </div>
                        </div>
                    </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-secondary" onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CountryModal;